export const BuyableType = {
    SUBSCRIBE:"عضویت",
    COURSE:"کلاس",
    PRODUCT:"محصول",
    FOOD:"غذا",
    SERVICE:"خدمات",
    DIET:"برنامه غذایی",
    WORKOUT:"برنامه ورزشی"
}
